import { API_URL } from "../config/connect";

const request = async (path, { method = "GET", body } = {}) => {
    const token = localStorage.getItem("google_id_token");
    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers: {
            Authorization: `Bearer ${token}`,
            ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        const d = data.detail;
        const message =
            (typeof d === "string" && d) ||
            (Array.isArray(d) && d.map((x) => `${(x.loc || []).slice(1).join(".")}: ${x.msg}`).join("; ")) ||
            `HTTP ${response.status}`;
        const error = new Error(response.status === 403 ? "Недостаточно прав." : message);
        error.status = response.status;
        throw error;
    }
    return response.json();
};

/** Все версии (история короткая — берём одной страницей) */
export const listAppVersions = () =>
    request("/api/v1/admin/app-version?page=1&limit=100").then((d) => (Array.isArray(d) ? d : d.items || d.versions || []));
export const createAppVersion = (body) => request("/api/v1/admin/app-version", { method: "POST", body });
export const updateAppVersion = (id, body) => request(`/api/v1/admin/app-version/${id}`, { method: "PATCH", body });
export const deleteAppVersion = (id) => request(`/api/v1/admin/app-version/${id}`, { method: "DELETE" });
